import { ref, watch } from '@vue/composition-api';

export default function useDebounce(state, timeout) {
    const timeoutId = ref(null);
    const debounced = ref(null);

    watch(state, () => {
        if (timeoutId.value) {
            clearTimeout(timeoutId.value);
        }
        timeoutId.value = setTimeout(() => {
            // clear state first to trigger reactivity
            debounced.value = state.value;
        }, timeout);
    });

    return debounced;
}
